import { acceptBooleanValue } from '../../field-viewer/shared-normalizers';
export const contactsSubscribeViewer = {
    normalizeLoadedValue: acceptBooleanValue
};

//# sourceMappingURL=definition-viewer.js.map